// removed by extract-text-webpack-plugin
module.exports = {"Notification":"Notification","Title":"Title","LogoSuccess":"LogoSuccess","LogoInfo":"LogoInfo","LogoWarning":"LogoWarning","LogoError":"LogoError","LogoDefault":"LogoDefault"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Notification/styles.scss
// module id = 1250
// module chunks = 10